import { render, staticRenderFns } from "./MaastaLayout.vue?vue&type=template&id=a9c426d0&"
import script from "./MaastaLayout.vue?vue&type=script&lang=js&"
export * from "./MaastaLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports